import { isPlainObject } from '@/libs/utils'

function easeInOutCubic (t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t * t + b
  } else {
    return c / 2 * ((t -= 2) * t * t + 2) + b
  }
}

export default class AnimateScroll {
  constructor (el) {
    this.el = el
    this.x = null
    this.y = null
    this.duration = null
    this.ms = null
    this.easingFn = null
  }

  scrollTo (to, duration = 700, easingFn = null) {
    this.duration = duration
    this.ms = new Date().getTime()
    this.easingFn = easingFn || easeInOutCubic
    this.progress = 0

    if (isPlainObject(to)) {
      this.x = to.x
      this.y = to.y
    } else {
      this.y = to
    }
    requestAnimationFrame(this._animate.bind(this))
  }

  _animate () {
    let startX
    let startY
    this.progress = new Date().getTime() - this.ms
    const isTimeout = this.progress >= this.duration

    if (this.el === window) {
      startX = this.el.pageXOffset
      startY = this.el.pageYOffset
    } else {
      startX = this.el.scrollLeft
      startY = this.el.scrollTop
    }

    let newTo = {
      x: startX,
      y: startY
    }

    if (typeof this.x === 'number') {
      const amountX = this.x - startX

      if (amountX) {
        if (isTimeout) {
          newTo.x = this.x
        } else {
          newTo.x = this.easingFn(this.progress, startX, amountX, this.duration)
        }
      }
    }

    if (typeof this.y === 'number') {
      const amountY = this.y - startY

      if (amountY) {
        if (isTimeout) {
          newTo.y = this.y
        } else {
          newTo.y = this.easingFn(this.progress, startY, amountY, this.duration)
        }
      }
    }

    if (this.el.scrollTo) {
      this.el.scrollTo(newTo.x, newTo.y)
    } else {
      this.el.scrollLeft = newTo.x
      this.el.scrollTop = newTo.y
    }

    if (!isTimeout) {
      requestAnimationFrame(this._animate.bind(this))
    }
  }
}
